import { render, staticRenderFns } from "./OrderIdReceipt.vue?vue&type=template&id=be6420e8&scoped=true"
import script from "./OrderIdReceipt.vue?vue&type=script&lang=js"
export * from "./OrderIdReceipt.vue?vue&type=script&lang=js"
import style0 from "./OrderIdReceipt.vue?vue&type=style&index=0&id=be6420e8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "be6420e8",
  null
  
)

export default component.exports